import { render, staticRenderFns } from "./PlansFilter.vue?vue&type=template&id=52321cb0&"
import script from "./PlansFilter.vue?vue&type=script&lang=js&"
export * from "./PlansFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports